// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-popper__inner:has(.notes-filter-wrapper){max-width:380px!important;width:90vw}.v-popper__inner:has(.notes-filter-wrapper):first-child{background:#e5e7eb}.note-actions-container{container-type:inline-size}@container (max-width: 500px){.note-actions-container>button{order:2}.note-actions-inputs{flex-basis:100%;order:1}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
